export default function getEnvironment() {
    const url = window.location.href;
    if (url.includes('//localhost') || url.includes('//127.0.0.1'))
        return 'localhost';
    if (url.includes('https://dev.') || url.includes('http://accounts-management-demo.') || url.includes('https://dev1.'))
        return 'development';
    if (url.includes('https://test.') || url.includes('.test.') || url.includes('https://aws-test') || url.includes('.test1.'))
        return 'test';
    if (url.includes('https://imp') || url.includes('.imp.') || url.includes('https://aws-impl'))
        return 'implementation';
    if (url.includes('https://uat'))
        return 'uat';
    if (url.includes('https://www.medicare') || url.includes('https://es.medicare'))
        return 'production';
    return 'default';
}